export { default } from './Renegociacao25Emprestimos';
